import { NativeModules, Platform } from 'react-native';
import { useAuthStore } from '@/store';
import { workClientEnvironment } from './appDistribution';
import { currentWorkRequest, getWorkAccessRequirement, getWorkAccessStatus } from '@/constants/utils/chat_work_access';

// Read-only preflight. Native launch performs its normal authoritative checks
// again, including connection revocation, server support and account changes.
export async function checkWorkRecommendationAccess(prompt, collectionId) {
  const requirement = getWorkAccessRequirement(prompt);
  const environment = { platform: Platform.OS, ...workClientEnvironment() };
  if (!['local-files', 'local-browser'].includes(requirement)) return getWorkAccessStatus(requirement, environment);
  const auth = useAuthStore.getState();
  const userId = auth.user?.id;
  const generation = auth._sessionGeneration;
  const current = () => {
    const state = useAuthStore.getState();
    return !!userId && state.user?.id === userId && state._sessionGeneration === generation && !state._isSigningOut;
  };
  try {
    if (environment.platform === 'macos' && environment.distribution === 'direct' && current()) {
      if (requirement === 'local-files') {
        const native = NativeModules.MacProjectFolder;
        const state = await native?.getState?.(String(userId));
        const selected = collectionId ? state?.collections?.[collectionId] : state?.selected;
        environment.localProject = !!selected && typeof native?.authorizeOriginalLocalLaunch === 'function';
      } else {
        const native = NativeModules.MacDesktopAccess;
        const state = await native?.getState?.(String(userId));
        const setup = await native?.getBrowserSetupState?.(String(userId));
        const requestedBrowser = currentWorkRequest(prompt).match(/\b(brave|chrome|edge|safari)\b/i)?.[1]?.toLowerCase();
        const connected = setup?.ok === true && setup.browsers?.some(browser => browser.connected === true
          && (!requestedBrowser || String(browser.name).toLowerCase() === requestedBrowser));
        environment.localBrowser = state?.enabled === true && state?.browser === true && state?.paused !== true
          && connected === true && typeof native?.authorizeOriginalDesktopLaunch === 'function';
      }
    } else if (['ios', 'android'].includes(environment.platform) && requirement === 'local-files') {
      const state = require('./remoteWork').useRemoteWorkStore?.getState();
      environment.remoteProject = state?.userId === userId && !!state?.selected?.projectId;
    }
  } catch {
    // Unknown or disconnected state never claims a working local connection.
  }
  if (!current()) return { canLaunch: false, notice: 'checkConnection' };
  return getWorkAccessStatus(requirement, environment);
}
